import React, { useState } from 'react'
import Left_panel from '../Left_panel'
import Sub_header from '../Sub_header'
import axios from 'axios'
import exportValue from '../../apiconfig'
import Swal from 'sweetalert2'
import moment from "moment";
import { TablePagination } from '@mui/material'

const Subscription_log = () => {
    const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
        const homeSection = document.querySelector('.home-section');
        if (homeSection) {
            homeSection.classList.toggle('sidebar-closed');
        }
    };
    const [logs,setLogs]=useState([]);

const [page,setPage]=useState(0);

const [rowsPerPage,setRowsPerPage]=useState(20);

const [count,setCount]=useState(0);

const [jpId,setJpId]=useState("");
const [fromDate, setFromDate] = useState("");

const [toDate, setToDate] = useState("");
        
        
        React.useEffect(()=>{
        
            getLogs();
        
        },[])
        React.useEffect(()=>{
        
            getLogs();
        
        },[page , rowsPerPage])
        
        
        const getLogs = ()=>{

            axios.post(
            
                exportValue.host+"/"+
                exportValue.version+"/"+
                exportValue.api+"/subscription_plan_logs",
            
            {
            page:page+1,
            limit:rowsPerPage,
            jp_id:jpId,
            from_date: fromDate,
            to_date: toDate
            },
            
            {
            headers:exportValue.headers
            }
            
            ).then(res=>{
            
            if(res.data.status){
            
            setLogs(res.data.data);
            
            setCount(res.data.total);
            
            }
            
            });
            
            }
        
        
        
     
        
  return (
    <div>
     

<Left_panel isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
<section class="home-section">
<Sub_header/>
<div className="container-fluid">


<div className="card mt-3">


<div className="card-header">


<h4>

Subscription Logs

</h4>


</div>




<div className="card-body">



<div className="row mb-3">

    <div className="col-md-3">
        <input
            className="form-control"
            placeholder="JP ID"
            value={jpId}
            onChange={(e)=>setJpId(e.target.value)}
        />
    </div>

    <div className="col-md-3">
        <input
            type="date"
            className="form-control"
            value={fromDate}
            onChange={(e)=>setFromDate(e.target.value)}
        />
    </div>

    <div className="col-md-3">
        <input
            type="date"
            className="form-control"
            value={toDate}
            onChange={(e)=>setToDate(e.target.value)}
        />
    </div>

    <div className="col-md-3">

        <button
            className="btn btn-primary me-2"
            onClick={()=>{
                setPage(0);
                getLogs();
            }}
        >
            Search
        </button>

        <button
            className="btn btn-secondary"
            onClick={()=>{
                setJpId("");
                setFromDate("");
                setToDate("");
                setPage(0);
            }}
        >
            Reset
        </button>

    </div>

</div>








<div className="jp-notification-log">
  <div className="card jp-notification-card shadow-sm border-0">
    <div className="card-header bg-white">
      <h5 className="mb-0 fw-bold">Subscription Logs</h5>
    </div>

    <div className="table-responsive">
      <table className="table mb-0 jp-notification-table">
        <thead>
          <tr>
            <th >Date</th>
            <th>JP ID</th>
            <th >Seller</th>
            <th >
            Brand
            </th>
            <th >
            Old Plan
            </th>
            <th >
            New Plan
            </th>
            <th >
            Amount
            </th>
            <th>Action</th>
            <th>Changed By </th>
          
          </tr>
        </thead>

        <tbody>

{

logs.map((item,index)=>(

<tr key={index}>

<td>{moment(item.createdAt).format("DD-MM-YYYY HH:mm")}</td>

<td>{item.customer?.jp_id}</td>

<td>{item.customer?.full_name}</td>

<td>{item.customer?.company_name}</td>

<td>{item.old_plan}</td>

<td>{item.new_plan}</td>

<td>₹{item.total_amount}</td>

<td>{item.action}</td>

<td>{item.changed_by_type}</td>

</tr>

))

}

</tbody>
      </table>
    </div>
  </div>
</div>

</div>
</div>
</div>
<TablePagination
component="div"
count={count}
page={page}
rowsPerPage={rowsPerPage}
onPageChange={(e,newPage)=>setPage(newPage)}
onRowsPerPageChange={(e)=>{
setRowsPerPage(parseInt(e.target.value));
setPage(0);
}}
/>
</section>

    </div>
  )
}

export default Subscription_log
